import { EmptyState } from "@freightsimple/ui-core/Display/EmptyState";
import { TruckIcon } from "@phosphor-icons/react/Truck";
import { useCarrierAuth } from "@/App/Auth/useCarrierAuth";
import { CarrierSignedOut } from "@/App/Auth/CarrierSignedOut";
import { CarrierIdentityPrompt } from "@/App/Auth/CarrierIdentityPrompt";
import { CarrierShell } from "@/App/CarrierShell";

export function App() {
  const { state, submitIdentity, signOut } = useCarrierAuth();

  switch (state.status) {
    case "loading":
      return <EmptyState icon={TruckIcon} title="Signing you in…" />;
    case "signedOut":
      return <CarrierSignedOut />;
    case "needsIdentity":
      return <CarrierIdentityPrompt onSubmit={submitIdentity} />;
    case "authed":
      return (
        <CarrierShell
          carrierIdentifier={state.session.carrierIdentifier}
          carrierName={state.session.carrierName}
          userName={state.session.userName}
          userEmail={state.session.userEmail}
          onSignOut={signOut}
        />
      );
  }
}
